import { lazy } from 'react';

import { FullLayout, AdminLayout } from 'layouts';
import Loadable from 'components/Loadable';
import { AuthGuard, GuestGuard } from 'components/guard';

const Login = Loadable(lazy(() => import('../pages/auth/Login')));

const Users = Loadable(lazy(() => import('../pages/admin/Users')));
const Players = Loadable(lazy(() => import('../pages/admin/Players')));
const CasinoHistory = Loadable(lazy(() => import('../pages/admin/CasinoHistory')));
const SportHistory = Loadable(lazy(() => import('../pages/admin/SportHistory')));
const OpenBets = Loadable(lazy(() => import('../pages/admin/OpenBets')));
const Transaction = Loadable(lazy(() => import('../pages/admin/Transaction')));
const Deposits = Loadable(lazy(() => import('../pages/admin/Deposits')));
const CashbackTransactions = Loadable(lazy(() => import('../pages/admin/CashbackTransactions')));
const CreateAccount = Loadable(lazy(() => import('../pages/admin/CreateAccount')));
const Setting = Loadable(lazy(() => import('../pages/admin/Setting')));
const Announcments = Loadable(lazy(() => import('../pages/admin/Announcments')));

export const AuthRoutes = {
    path: '/',
    element: (
        <GuestGuard>
            <FullLayout />
        </GuestGuard>
    ),
    children: [
        {
            path: '/login',
            element: <Login />
        },
        {
            path: '/webLogin',
            element: <Login />
        }
    ]
}

export const AdminRoutes = {
    path: '/admin',
    element: (
        <AuthGuard>
            <AdminLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: 'users',
            element: <Users />
        },
        ...(process.env.REACT_APP_SHOW_ADMIN_PLAYERS_TAB === 'true' ? [{
            path: 'players',
            element: <Players />
        }] : []),
        {
            path: 'casino-history',
            element: <CasinoHistory />
        },
        {
            path: 'sport-history',
            element: <SportHistory />
        },
        {
            path: 'open-bets',
            element: <OpenBets />
        },
        {
            path: 'transaction',
            element: <Transaction />
        },
        {
            path: 'deposits',
            element: <Deposits />
        },
        {
            path: 'cashback-transactions',
            element: <CashbackTransactions />
        },
        {
            path: 'create-account',
            element: <CreateAccount />
        },
        {
            path: 'setting',
            element: <Setting />
        },
        {
            path: 'announcements',
            element: <Announcments />
        }
    ]
}
